import script from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./ProjectForm.vue?vue&type=style&index=0&id=1e89266c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e89266c"]])

export default __exports__